import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from '~/app/shared/layouts/auth-layout/auth-layout.component';
import { ConfirmSmsComponent } from './confirm-sms/confirm-sms.component';
import { LoginComponent } from './login/login.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { NewPhoneComponent } from './new-phone/new-phone.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import MicrosoftCallbackPage from './microsoft-callback.page';

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
      {
        path: 'new-password',
        component: NewPasswordComponent,
      },
      {
        path: 'new-phone',
        component: NewPhoneComponent,
      },
      {
        path: 'confirm-sms',
        component: ConfirmSmsComponent,
      },
      {
        path: 'microsoft-callback',
        component: MicrosoftCallbackPage,
      },
      {
        path: '**',
        component: LoginComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
